import { notEmpty } from "@product/scmp-sdk";
import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import type {
  genericPostiesArticleVocabBoxArticle$data,
  genericPostiesArticleVocabBoxArticle$key,
} from "~/queries/__generated__/genericPostiesArticleVocabBoxArticle.graphql";

import IconSayIt from "./icon-say-it.png";
import { GenericPostiesArticleNumberIcon } from "./number-icon";
import {
  Container,
  StyledContentSchemaRender,
  StyledIconSayIt,
  StyledIconSayItContainer,
  StyledTerm,
  StyledTermAndTranslation,
  StyledText,
  StyledTranslation,
  StyledVocab,
  StyledVocabBox,
  StyledVocabBoxContainer,
} from "./styles";

type Props = {
  className?: string;
  reference: genericPostiesArticleVocabBoxArticle$key;
};

export const GenericPostiesArticleVocabBox: FunctionComponent<Props> = ({
  className,
  reference,
}) => {
  const article = useFragment(
    graphql`
      fragment genericPostiesArticleVocabBoxArticle on Article {
        glossary {
          term
          translation
          description {
            json
          }
        }
        ...contentSchemaRenderContent
      }
    `,
    reference,
  );

  const renderContent = (glossary: genericPostiesArticleVocabBoxArticle$data["glossary"]) => (
    <Container className={className}>
      <StyledIconSayItContainer>
        <StyledIconSayIt alt={IconSayIt.alt} src={IconSayIt.src} />
      </StyledIconSayItContainer>
      <StyledVocabBoxContainer>
        <StyledVocabBox>
          {glossary?.map?.((item, key) => {
            if (!item) return null;
            const { description, term, translation } = item;
            return (
              <StyledVocab key={key}>
                <GenericPostiesArticleNumberIcon number={key + 1} />
                <StyledText>
                  <StyledTermAndTranslation>
                    <StyledTerm>{term}</StyledTerm>
                    <StyledTranslation>{translation}</StyledTranslation>
                  </StyledTermAndTranslation>
                  <StyledContentSchemaRender reference={article} schema={description?.json} />
                </StyledText>
              </StyledVocab>
            );
          })}
        </StyledVocabBox>
      </StyledVocabBoxContainer>
    </Container>
  );

  if (!article || !notEmpty(article.glossary)) return null;
  return renderContent(article.glossary);
};

GenericPostiesArticleVocabBox.displayName = "GenericPostiesArticleVocabBox";
